// extracted by mini-css-extract-plugin
export default {"dock":"dock_dock__3jzj+","dockContainer":"dock_dockContainer__ewuWb"};